<div class="questionnaire-cell clickable"
  [ngClass]="{'questionnaire-cell_selected': activeQuestionnaire ? questionnaire.questionnaire_id == activeQuestionnaire.questionnaire_id : false}">
  <div class="title text-color-primary">
    {{questionnaire.title}}
  </div>
  <div class="status-icon" *ngIf="!questionnaire.answered">
    <div class="icon unread-bubble"></div>
  </div>
</div>